import isMobile from './mobile.js';

function storePageOffsetY() {
    if (typeof Storage !== 'undefined' && window.pageYOffset !== 0) {
        window.sessionStorage.setItem('pageOffsetY', window.pageYOffset);
    }
}

function resetPageOffsetY() {
    if (typeof Storage !== 'undefined') {
        window.sessionStorage.setItem('pageOffsetY', 0);
    }
}

export function enableBodyScroll() {
    if (isMobile()) {
        document.body.classList.remove('no-scroll');
        window.scrollTo(0, window.sessionStorage.getItem('pageOffsetY')); // Thanks iOS
        resetPageOffsetY();
    }
}

export function disableBodyScroll() {
    if (isMobile()) {
        storePageOffsetY();
        document.body.classList.add('no-scroll');
        window.scrollTo(0, 1); // iOS needs to scroll to top when overlay opens
    }
}
